import React from "react";
import clsx from "clsx";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { useIntl } from "react-intl";

import styles from "./AuthorDisplay.module.css";

export default function AuthorDisplay({
  className,
  id,
  image,
  fullName,
  role,
  bio,
}) {
  const intl = useIntl();

  const letters = fullName.split(" ").map((s) => s.substring(0, 1));
  const initials = [letters[0], letters[letters.length - 1]]
    .join("")
    .toUpperCase();

  const link = `/${intl.locale}/authors/${id}`;

  return (
    <>
      <div className={clsx(styles.container, className)}>
        <Link to={link}>
          {image ? (
            <Img
              fixed={image.childImageSharp.bigger}
              className={styles.avatar}
            />
          ) : (
            <div className={styles.avatar}>{initials}</div>
          )}
        </Link>
        <div className={styles.info}>
          <Link to={link} className={styles.name}>
            {fullName}
          </Link>
          <div className={styles.role}>{role[intl.locale]}</div>
          <div className={styles.bio}>{bio[intl.locale]}</div>
        </div>
      </div>
    </>
  );
}
